const BOT_USER_AGENT_PATTERN =
  /bot|crawler|crawling|spider|slurp|meta-externalagent|facebookexternalhit|headlesschrome|lighthouse|bingpreview|google-inspectiontool|mediapartners-google|phantomjs|prerender/i;

const DEVICE_NAMES_CONTAINING_BOT = /cubot/gi;

export function isBotUserAgent(userAgent: string): boolean {
  return BOT_USER_AGENT_PATTERN.test(userAgent.replace(DEVICE_NAMES_CONTAINING_BOT, ''));
}
